import { Component, Input, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Banniere, BanniereService } from '@helvetia/components'
import { Market } from 'src/app/models/market'
import { MarketService } from 'src/app/services/market.service'

@Component({
  selector: 'app-edit-market',
  templateUrl: './edit-market.component.html',
  styleUrls: ['./edit-market.component.scss']
})
export class EditMarketComponent implements OnInit {

  market = new Market()

  listImg = ['armateur.svg', 'construction.svg', 'dommages aux biens.svg', 'flottes automobiles.svg', 'fluvial.svg', 
    'plaisance.svg', 'emailing commerciaux.svg', 'digital.svg', 'helvetia france.svg', 'international.svg', 'marchandises transportées.svg', 
    'oeuvres d\'art.svg', 'organigrammes.svg', 'pêche.svg', 'portuaire.svg', 'responsabilité civile entreprises.svg', 'risques techniques.svg', 
    'sanctions internationales.svg', 'transporteurs & logisticiens.svg']
  imgSelected = this.market.icon
  idMarket: any

  constructor(public marketService: MarketService,
    public router: Router,
    private banniereService: BanniereService
  ) {
    this.idMarket = parseInt(window.location.pathname.split('/').slice(-1)[0])
  }

  ngOnInit(): void {
    if (!isNaN(this.idMarket)) {
      this.marketService.getMarketById(this.idMarket).subscribe(
        (market) => {
          this.market = market
          this.imgSelected = this.market.icon
        }
      )
    }
  }

  updateMarket() {
    if (!isNaN(this.idMarket)) {
      this.marketService.updateMarket(this.market).subscribe(
        (data) => {
          let banniere = new Banniere()
          banniere.text = 'Le marché a bien été modifié'
          banniere.status = 'success'
          this.banniereService.setStatus(banniere)
          this.router.navigate(['documents'])
        }
      )
    } else {
      this.marketService.postMarket(this.market).subscribe(
        (data) => {
          let banniere = new Banniere()
          banniere.text = 'Le marché a bien été créé'
          banniere.status = 'success'
          this.banniereService.setStatus(banniere)
          this.router.navigate(['documents'])
        }
      )
    }
  }

  selectedIcon(img: any) {
    this.imgSelected = img
    this.market.icon = this.imgSelected
  }

}
